"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _styles = require("@material-ui/core/styles");
var _CloudUpload = _interopRequireDefault(require("@material-ui/icons/CloudUpload"));
var _InsertPhoto = _interopRequireDefault(require("@material-ui/icons/InsertPhoto"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _reactDropzone = require("react-dropzone");
var _clsx = _interopRequireDefault(require("clsx"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withFormField = _interopRequireDefault(require("../hocs/withFormField"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    message: {
      fontWeight: 'bold',
      fontSize: 'inherit'
    },
    uploadIcon: {
      color: theme.palette.secondary.main,
      cursor: 'pointer',
      fontSize: 48
    },
    dropZone: {
      borderRadius: 9,
      border: '3px dashed',
      backgroundColor: (0, _styles.fade)(theme.palette.lightGrey.light, 0.5),
      borderColor: (0, _styles.fade)(theme.palette.primary.light, 0.5),
      textAlign: 'center',
      padding: theme.spacing(3),
      transition: 'background-color 0.5s, border-color 0.5s',
      '& button': {
        color: theme.palette.secondary.main,
        cursor: 'pointer',
        border: 'none',
        background: 'inherit',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        padding: 0,
        '&:focus': {
          outline: 'none'
        }
      },
      '&:focus': {
        outline: 'none'
      },
      '&$disabled': {
        color: theme.palette.darkGrey.light,
        borderColor: (0, _styles.fade)(theme.palette.darkGrey.light, 0.5),
        '& button, & $uploadIcon': {
          color: (0, _styles.fade)(theme.palette.darkGrey.light, 0.5)
        }
      }
    },
    dragging: {
      backgroundColor: (0, _styles.fade)(theme.palette.lightGrey.main, 0.8),
      borderColor: (0, _styles.fade)(theme.palette.primary.light, 0.8)
    },
    disabled: {},
    uploaded: {
      backgroundColor: (0, _styles.fade)(theme.palette.secondary.main, 0.2),
      color: theme.palette.secondary.dark,
      borderRadius: '5px 5px 0 0',
      margin: theme.spacing(1, 0),
      padding: theme.spacing(1, 2),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    uploadedIcon: {
      color: (0, _styles.fade)(theme.palette.secondary.dark, 0.5)
    },
    fileName: {
      width: '100%',
      margin: theme.spacing(0, 2)
    },
    removeIconButton: {
      padding: 0
    }
  };
});
var FileInput = function FileInput(_ref) {
  var handleChange = _ref.handleChange,
    info = _ref.info,
    files = _ref.value,
    disabled = _ref.disabled,
    accept = _ref.accept,
    multiple = _ref.multiple,
    type = _ref.type;
  var classes = useStyles();
  var onDrop = (0, _react.useCallback)(function (acceptedFiles, rejectedFiles) {
    if (!!rejectedFiles && !!rejectedFiles.length) console.error('Rejected:', rejectedFiles); // eslint-disable-line no-console
    if (acceptedFiles.length && multiple) handleChange([].concat(_toConsumableArray(files), _toConsumableArray(acceptedFiles)));else if (acceptedFiles.length) handleChange(_toConsumableArray(acceptedFiles));
  }, [files, handleChange]);
  var removeFile = (0, _react.useCallback)(function (index) {
    return function () {
      var newFiles = _toConsumableArray(files);
      newFiles.splice(index, 1);
      handleChange(newFiles);
    };
  }, [files, handleChange]);
  var accetpFileTypes = accept;
  if (type === 'image') if (typeof accept === 'string') accetpFileTypes = "".concat(accept, ", .heic, .heif, image/*");else if (Array.isArray(accept)) accetpFileTypes = ['.heic', '.heif', 'image/*'].concat(_toConsumableArray(accept));else accetpFileTypes = '.heic, .heif, image/*';
  var _useDropzone = (0, _reactDropzone.useDropzone)({
      disabled: disabled,
      accept: accetpFileTypes,
      multiple: multiple,
      onDrop: onDrop
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive;
  var hasSelectedFiles = !!files && !!files.length;
  return /*#__PURE__*/_react["default"].createElement("div", null, hasSelectedFiles && files.map(function (file, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.uploaded,
      key: "".concat(file.name).concat(file.lastModified),
      onClick: function onClick(e) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      },
      onKeyDown: function onKeyDown(e) {
        return e.stopPropagation();
      },
      role: "button",
      tabIndex: 0
    }, type === 'image' ? /*#__PURE__*/_react["default"].createElement(_InsertPhoto["default"], {
      className: classes.uploadedIcon
    }) : /*#__PURE__*/_react["default"].createElement(_CloudUpload["default"], {
      className: classes.uploadedIcon
    }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      className: classes.fileName
    }, file.name), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      onClick: removeFile(index),
      size: "small",
      color: "inherit",
      "aria-label": "remove"
    }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      fontSize: "inherit"
    })));
  }), /*#__PURE__*/_react["default"].createElement("div", getRootProps({
    className: (0, _clsx["default"])(classes.dropZone, isDragActive && classes.dragging, disabled && classes.disabled)
  }), /*#__PURE__*/_react["default"].createElement("input", getInputProps()), type === 'image' ? /*#__PURE__*/_react["default"].createElement(_InsertPhoto["default"], {
    className: classes.uploadIcon
  }) : /*#__PURE__*/_react["default"].createElement(_CloudUpload["default"], {
    className: classes.uploadIcon
  }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.message,
    variant: "body1"
  }, type === 'image' ? /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "buttons:dragImageOrExplore"
  }, "Drag your image or ", /*#__PURE__*/_react["default"].createElement("button", {
    type: "button"
  }, "explore")) : /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "buttons:dragFileOrExplore"
  }, "Drag your file or ", /*#__PURE__*/_react["default"].createElement("button", {
    type: "button"
  }, "explore"))), info));
};
FileInput.propTypes = {
  value: _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(File)).isRequired,
  handleChange: _propTypes["default"].func.isRequired,
  info: _propTypes["default"].node,
  accept: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  multiple: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(['file', 'image'])
};
FileInput.defaultProps = {
  multiple: false,
  accept: undefined,
  info: undefined,
  disabled: undefined,
  type: 'file'
};
var _default = exports["default"] = (0, _withFormField["default"])({})(FileInput);